import TableCell from "@mui/material/TableCell";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { isSuperAdmin } from "../../../../utils/role";
import { Button } from "@mui/material";
import CustomButton from "../../../../atoms/Button";

type Props = {
  row: any;
  handleDelete: any;
};
const TableCellsRow = ({ row, handleDelete }: Props) => {
  return (
    <>
      <TableCell sx={{ width: '70%' }} align="left" key={"label-" + row?.id?.toString()}>
        {row}
      </TableCell>
      {<TableCell sx={{ width: '30%' }} align="left" key={"action-" + row?.id?.toString()}>
          <CustomButton onClick={() => handleDelete(row)} disabled={!isSuperAdmin()}>
            <DeleteOutlinedIcon sx={{ fontSize: "20px", color: 'primary.main'}}  />
          </CustomButton>
      </TableCell>}
    </>
  );
};

export default TableCellsRow;
